// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal-dialog {
  max-width: 600px !important;
  /*max-height: 550px !important;
  overflow: hidden;*/
}

#striped-light .card {
  margin: 0;
}

form .col-form-label {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.addNewManufacturer {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/procedures/modals/manageprocedure.screen.component.scss"],"names":[],"mappings":"AAAA;EACC,2BAAA;EACA;oBAAA;AAED;;AAEC;EACC,SAAA;AACF;;AAGA;EACC,gBAAA;EACG,oBAAA;EACA,sBAAA;AAAJ;;AAEA;EACC,gBAAA;AACD","sourcesContent":["div.modal-dialog  {\n\tmax-width:600px !important;\n\t/*max-height: 550px !important;\n\toverflow: hidden;*/\n}\n#striped-light {\n\t.card {\n\t\tmargin:0;\n\t}\n}\n\nform .col-form-label {\n\tfont-weight: 400;\n    text-transform: none;\n    letter-spacing: normal;\n}\n.addNewManufacturer{\n\tmargin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
